import React from 'react'
import useDockDeviceObserver from './useDockDeviceObserver'
import useDeviceFlightAuthorityObserver from './useDeviceFlightAuthorityObserver';
import usePsdkDeviceObserver from './usePsdkDeviceObserver';

function useDeviceObserver() {
  const dockObserver = useDockDeviceObserver();
  const psdkObserver = usePsdkDeviceObserver();
  const deviceFlightAuthorityObserver = useDeviceFlightAuthorityObserver();
  
  return {
    ...dockObserver,
    // Add other device observers here
  };
}

export default useDeviceObserver